import React, { FunctionComponent } from 'react';

import { useSelector } from 'react-redux';
import AppState from '@webapp/store/state';

import styled from 'styled-components';

import Grid from '@components/basics/grid';
import Flex from '@components/layout/flex';
import Typography from '@components/basics/typography';
import SquareImg from '@components/basics/artwork-img';

import { MerchProduct } from '@services/merch/types/api/merch-product';
import { Translate } from 'react-localize-redux';
import { getMergedReleaseListSummary } from '@webapp/store/release/selectors';

interface ArtistDesktopMerchRowProps {
  item: MerchProduct;
}

const ArtistDesktopMerchRow: FunctionComponent<ArtistDesktopMerchRowProps> = ({
  item,
}) => {
  const release = useSelector((state: AppState) =>
    getMergedReleaseListSummary(state).find((r) => r.id === item.releaseId)
  );

  return (
    <Wrapper>
      <Flex
        className="info"
        justifyContent="space-between"
        alignItems="center"
        gap={10}
      >
        {!item.releaseId || !release ? (
          <Typography type="small">—</Typography>
        ) : (
          <Flex justifyContent="flex-start" alignItems="center" gap={20}>
            <SquareImg
              size={36}
              srcImg={release?.cover_url}
              altImg={item.releaseName}
            />
            <Grid gap={3}>
              <Typography customFont="semi-bold">{release?.title}</Typography>
              {release?.upc ? (
                <Typography type="small">{release.upc}</Typography>
              ) : null}
            </Grid>
          </Flex>
        )}
      </Flex>

      <div className="third-column">
        {/* TODO: Quality is not typed in MerchProduct */}
        {/* <Typography type="small">{item.quality}</Typography> */}
      </div>
      <div className="fourth-column">
        <Typography type="small">
          {item.unlimitedQty ? (
            <Translate id="COMMON.UNLIMITED" />
          ) : item.availableQty ? (
            item.availableQty
          ) : (
            0
          )}
        </Typography>
      </div>
    </Wrapper>
  );
};

export default ArtistDesktopMerchRow;

const Wrapper = styled.div`
  display: grid;
  align-items: center;
  grid-gap: 24px;
  grid-template-columns: repeat(18, minmax(0, 1fr));

  .avatar {
    grid-column: 1 / 2;
  }

  .info {
    grid-column: 2 / 8;
  }

  .third-column {
    grid-column: 8 / 11;
  }

  .fourth-column {
    grid-column: 11 / 15;
  }
`;

export const SongNumber = styled(Flex)`
  width: 24px;
  height: 24px;
  flex-shrink: 0;
  border-radius: 50%;
  background-color: ${({ theme }) => theme.colors.primary};

  .number {
    color: ${({ theme }) => theme.colors.differentBackground};
  }

  &.nft {
    background-color: ${({ theme }) => theme.colors.secondary};

    .number {
      color: ${({ theme }) => theme.colors.tertiary};
    }
  }
`;
